/* eslint-disable react/prop-types */
import React from 'react';

import '~styles/modules/teasers.scss';

const Teasers = ({ relatedlinks }) => {
  const list = relatedlinks.map((teaser) => (
    <li className="teasers__item" key={teaser.url}>
      <a className="teasers__link" href={teaser.url} target="_blank" rel="noreferrer">
        <div className="teasers__image-container">
          <img
            className="teasers__image"
            src={teaser.promoImage.url}
            srcSet={teaser.promoImage.srcSet}
            sizes="(max-width: 350px) 550px, (max-width: 640px) 1000px, 800px"
            alt="/"
          />
        </div>
        <h3 className="teasers__hed miller-n6">{teaser.headlines.basic}</h3>
      </a>
    </li>
  ));

  return (
    <div className="teasers">
      <h4 className="teasers__title benton-n6">Up next</h4>
      <ul className="teasers__list">
        {list}
      </ul>
    </div>
  );
};

export default Teasers;
